import { WorkCenterWeek } from '../Incrementals.types';
import { UiCommands } from './UiCommands';

export function changeJustificationReasonCommand(
  this: UiCommands,
  workCenterWeek: WorkCenterWeek,
  justificationReasonId: string
): void {
  // note: this only works because the workCenterWeek is the same one
  // in the uiState; otherwise the code would need to look up the workCenterWeek
  // from within uiState
  const editWorkCenterWeek = workCenterWeek;

  // there will always be a match
  const justificationReason = this.uiState.justificationReasons.filter(
    (justificationReasonElement) =>
      justificationReasonElement.id === justificationReasonId
  )[0];

  editWorkCenterWeek.justificationReason = justificationReason;

  this.setUiStateTriggerReRender(this.uiState);
}
